import { render, staticRenderFns } from "./landnumdetail.vue?vue&type=template&id=6d919294&scoped=true&"
import script from "./landnumdetail.vue?vue&type=script&lang=js&"
export * from "./landnumdetail.vue?vue&type=script&lang=js&"
import style0 from "./landnumdetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./landnumdetail.vue?vue&type=style&index=1&id=6d919294&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d919294",
  null
  
)

export default component.exports